import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { AttachmentDialogComponent } from './attachment-dialog.component'
import { Attachment } from '@tokeet-frontend/tv3-platform'
import { SharedModule } from '@tv3/shared/shared.module'
import { Observable } from 'rxjs'
import { AttachmentUploadComponentOptions } from './upload/attachment-upload.component'

@Injectable({
  providedIn: SharedModule,
})
export class AttachmentDialogService {
  constructor(private dialog: MatDialog) {}

  public open(uploadOptions?: AttachmentUploadComponentOptions, selectFromExisting = false): Observable<Attachment[]> {
    const defaultConfig: MatDialogConfig = {
      width: '600px',
      height: 'auto',
      panelClass: ['variable-modal'],
      data: {
        uploadOptions,
        selectFromExisting,
      },
    }

    return this.dialog.open(AttachmentDialogComponent, defaultConfig).afterClosed()
  }
}
